import React from 'react';
import {FeaturesList, Grid2Columns, Item, SectionHeader} from '../utils/Styled';
import {Trans} from 'gatsby-plugin-react-i18next';
import {MenuItemIcon} from '../utils/MenuItemIcon';
import {InternalPageLink} from 'components/links/Pages';
import {MenuLink, Props} from '../utils/types';
import {ecommerceItems, retailInStoreItems, freelancersItems} from '../constants/useCases';

export const UseCases: React.FC<Props> = ({itemClick}) => {
  const renderItem = (item: MenuLink, index: number) => (
    <Item key={(item.slug || '') + '-' + index}>
      <MenuItemIcon name={item.icon} />
      {item.slug ? (
        <InternalPageLink slug={item.slug} activeClassName="active" onClick={itemClick}>
          {item.title}
        </InternalPageLink>
      ) : (
        item.title
      )}
    </Item>
  );

  return (
    <Grid2Columns columnWidth="220px">
      <div>
        <SectionHeader marginTop="0">
          <Trans>Online Payments</Trans>
        </SectionHeader>
        <FeaturesList>{ecommerceItems.map((item, index) => renderItem(item, index))}</FeaturesList>
      </div>
      <div>
        <SectionHeader marginTop="0">
          <InternalPageLink
            slug="monei-pay/retail-POS-system"
            onClick={itemClick}
            style={{fontWeight: 600}}>
            <Trans>Retail & In-Store Payments</Trans>
          </InternalPageLink>
        </SectionHeader>
        <FeaturesList>
          {retailInStoreItems.map((item, index) => renderItem(item, index))}
        </FeaturesList>

        <SectionHeader marginTop="24px">
          <Trans>Freelancers & Practices</Trans>
        </SectionHeader>
        <FeaturesList>
          {freelancersItems.map((item, index) => renderItem(item, index))}
        </FeaturesList>
      </div>
    </Grid2Columns>
  );
};
